/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputSuggestedSearchWord
 */
export interface InputSuggestedSearchWord {
    /**
     * 
     * @type {string}
     * @memberof InputSuggestedSearchWord
     */
    word: string;
    /**
     * 
     * @type {string}
     * @memberof InputSuggestedSearchWord
     */
    wordId: string;
    /**
     * 
     * @type {string}
     * @memberof InputSuggestedSearchWord
     */
    wordScore: string;
    /**
     * 
     * @type {string}
     * @memberof InputSuggestedSearchWord
     */
    wordLanguage: string;
}

/**
 * Check if a given object implements the InputSuggestedSearchWord interface.
 */
export function instanceOfInputSuggestedSearchWord(value: object): value is InputSuggestedSearchWord {
    if (!('word' in value) || value['word'] === undefined) return false;
    if (!('wordId' in value) || value['wordId'] === undefined) return false;
    if (!('wordScore' in value) || value['wordScore'] === undefined) return false;
    if (!('wordLanguage' in value) || value['wordLanguage'] === undefined) return false;
    return true;
}

export function InputSuggestedSearchWordFromJSON(json: any): InputSuggestedSearchWord {
    return InputSuggestedSearchWordFromJSONTyped(json, false);
}

export function InputSuggestedSearchWordFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputSuggestedSearchWord {
    if (json == null) {
        return json;
    }
    return {
        
        'word': json['word'],
        'wordId': json['word_id'],
        'wordScore': json['word_score'],
        'wordLanguage': json['word_language'],
    };
}

export function InputSuggestedSearchWordToJSON(json: any): InputSuggestedSearchWord {
    return InputSuggestedSearchWordToJSONTyped(json, false);
}

export function InputSuggestedSearchWordToJSONTyped(value?: InputSuggestedSearchWord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'word': value['word'],
        'word_id': value['wordId'],
        'word_score': value['wordScore'],
        'word_language': value['wordLanguage'],
    };
}

